<div class="h-100 d-flex flex-column">
    <common-header></common-header>
    <div class="create-user-analytics-container d-flex align-items-center justify-content-center">
        <div [ngClass]="'theme-'+currentTheme.id" class="start-learning-container px-0" id="auto-entitlement-welcome-ele">
            <div class='welcome text-center'>
                <img class="img-margin mb-4" src="{{imageBasePath}}assets/img/shield.svg" alt='{{"_COMMON_ACROSS_MODULES.DOWNLOAD_APP_BANNER.ICON_ALT" | translate}}'>
                <h1 class="heading">{{ 'LEARNER.CREATE_USER_ANALYTICS.WELCOME_TEXT' | translate}}</h1>
                <p class="description">{{ 'LEARNER.CREATE_USER_ANALYTICS.DESCRIPTION_TEXT' | translate }}</p>
                <div class="progress mt-3 mb-2">
                    <div class="progress-bar" id="progressBar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [ngClass]="{'progress-bar-border': progressBar}"></div>
                </div>
                <div *ngIf="progressBar">{{ widthOfProgressBar }}%</div>
            </div>
        </div>
    </div>
    <footer></footer>
</div>